import { BlockBlobClient } from "@azure/storage-blob";

const baseApi = process.env.REACT_APP_API_BASE;

export const uploadFileToAzure = async (file, user) => {
  const res = await fetch(`${baseApi}azure/getAzureLink`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user?.token}`,
    },
    body: JSON.stringify({ fileName: file.name }),
  });

  if (!res.ok) {
    throw new Error("Failed to get SAS URL");
  }

  const { sasUrl, blobUrl } = await res.json();

  const blockBlobClient = new BlockBlobClient(sasUrl);
  await blockBlobClient.uploadBrowserData(file, {
    blobHTTPHeaders: { blobContentType: file.type },
  });

  return blobUrl;
};

export const uploadPublicFileToAzure = async (file, user) => {
  const res = await fetch(`${baseApi}azure/getAzurePublicLink`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user?.token}`,
    },
    body: JSON.stringify({
      fileName: file.name,
    }),
  });

  if (!res.ok) {
    throw new Error("Failed to get upload URL");
  }

  const { uploadUrl, blobUrl } = await res.json();

  const blockBlobClient = new BlockBlobClient(uploadUrl);
  const uploadResponse = await blockBlobClient.uploadBrowserData(file, {
    blobHTTPHeaders: { blobContentType: file.type },
  });

  if (uploadResponse.errorCode) {
    throw new Error("Failed to upload file");
  }

  return blobUrl;
};

export const downloadFileToAzure = async (file, user) => {
  const fileName = file.linkUrl.split("/gcm-uploads/")[1];
  const res = await fetch(`${baseApi}azure/getAzureLinkDownload`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user?.token}`,
    },
    body: JSON.stringify({ fileName: fileName }),
  });

  if (!res.ok) {
    throw new Error("Failed to get SAS URL");
  }

  const { sasUrl } = await res.json();

  //${file.linkUrl}?
  return sasUrl;
};

export const downloadFileToAzureVersion2 = async (file, user) => {
  console.log(file);
  const fileName = file.url.split("/gcm-uploads/")[1];
  const res = await fetch(`${baseApi}azure/getAzureLinkDownload`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${user?.token}`,
    },
    body: JSON.stringify({ fileName: fileName }),
  });

  if (!res.ok) {
    throw new Error("Failed to get SAS URL");
  }

  const { sasUrl } = await res.json();

  //${file.linkUrl}?
  return sasUrl;
};
